import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StyledBackButton = styled(Button)`
  display: block;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;

  &.back-button-middle {
    display: none;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
    display: inline;
    width: auto;
  }

  @media (min-width: 1415px) {
    .back-button-bottom {
      display: none;
    }
    .back-button-middle {
      display: inline;
    }
  }
`;

class BackButton extends Component {
  handleClick = e => {
    const { to, navigateBack, beforeNav } = this.props;

    if (beforeNav) {
      beforeNav();
    }

    navigateBack(to);
  };

  render() {
    const { className, ...props } = this.props;

    return (
      <StyledBackButton
        className={`${className} back-btn`.trim()}
        onClick={this.handleClick}
        type="button"
        {...props}
      >
        <FontAwesomeIcon icon="chevron-left" role="presentation" /> Back
      </StyledBackButton>
    );
  }
}

BackButton.propTypes = {
  className: PropTypes.string,
  navigateBack: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
  beforeNav: PropTypes.func
};

export default BackButton;
